<template>
    <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto; overflow-x: auto;" class="px-4 py-4">
      <v-row class="pa-2 customer" :style="{ marginBottom: role < 6 ? '10px' : '0px' }">
        <v-col cols="9" class="py-0 d-flex align-center ga-5">
          <h2 class="clientname">Shipping Details</h2>
          <TemplateDownload v-if="role < 6" :data="excelTemplate" text="Shipping"/>
        </v-col>
        <v-col cols="3" class="py-0 d-flex align-right justify-end">
            <ExcelUpload v-if="role < 6" @uploaded="addCustomer" showCard="customer"/>
            <!-- <v-btn color="primary" variant="elevated">
                <v-icon start size="20">mdi-plus</v-icon>
                Add
            </v-btn> -->
            <!-- <Export :data="shippingDetails" text="shipping"/> -->
        </v-col>
      </v-row>
      <div class="pa-2 table-container" style="height: 100%; width: 100%; overflow-x: auto;">
        <Table v-if="headers.length>0" @dialogs="edit" :title="'Shipping Details'" :role="role" :headers="headers" :dataList="shippingDetails" />
      </div>
    </v-card>
    <v-dialog v-model="shippingDialog" width="800">
      <ShippingForm @update-location="updateLocation" :index="index" :viewType="viewType" :designation="'Customers'" :shippingForm="shippingForm"  @close="close"/>
    </v-dialog>
  </template>
  
  <script>
import ExcelUpload from '@/menus/ExcelUpload.vue';
// import Export from '@/menus/Export.vue';
import DatamodelDetailsService from '@/api/service/DataModelDetails/DataModelsDetailsService';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import TemplateDownload from '@/menus/TemplateDownload.vue';
import moment from "moment";
import Table from '@/menus/Table.vue'
import ShippingForm from './ShippingForm.vue';



  export default {
    components: {
        ExcelUpload,
        Table,
        // Export,
        TemplateDownload,
        ShippingForm
    },
    data() {
      return {
        headers:[],
        customer:[],
        shippingForm:[],
        shippingDetails:[],
        excelTemplate:[],
        user_id:null,
        user_name:null,
        shippingDialog:false,
        role:null,
      }
    },
    created() {
        this.getOrganisation()
        this.getModeldata()
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.user_id = user.id
        this.user_name = user.username
        this.role = user.roles.role_type
        console.log(this.user_id,"this.user_id!!")
    },
    methods: {
        async getModeldata(){
            try {
              let res = await DatamodelDetailsService.findAll({model_id:26,column_required:1})
              console.log(res,"res!!###")
              this.headers = res || []
              this.headers.forEach((item)=>{
                item.column_name == 'shipping_instruction'?item.minWidth='400px':item.minWidth='200px'
                item.title = item.label
                item.value = item.column_name
                this.excelTemplate.push(item.column_name)
              })
              this.headers.push({ title: "Actions", value: 'actions', minWidth: '150px',})
              console.log(this.headers,"this.headers")
            } catch (error) {
              console.log(error)
            }
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            this.shippingDetails = this.organisationData && this.organisationData.shipping ? this.organisationData.shipping : this.shippingDetails
        },

        async save() {
            console.log("tttt!!!")
            this.organisationData.shipping = this.shippingDetails
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id:this.$route.query.id
            }
            await clientDetailsService.update($data)
        },
        close() {
            this.shippingDialog = false
        },
        addCustomer($data){
            this.shippingDetails = $data
            let count = 0
            if(this.organisationData && this.organisationData.shipping && Array.isArray(this.organisationData.shipping)){
              count = this.organisationData.shipping.length
            }
            for(let i of this.shippingDetails){
              const now = moment().format('YYYY-MM-DD HH:mm:ss')
                i.id = ++count
                i.created = now
                i.modified = null
                i.created_by = this.user_id  
                i.modified_by = null
                i.active = 1
                i.deleted = 0
                i.deleted_by = null
              console.log(i ,"loop")
            }
            this.save()
        console.log($data,'geufeu')
        },

        async edit($edit,bool,viewType,index){
          this.shippingDialog=true
          this.shippingForm = $edit
          this.viewType = viewType
          this.index = index
          console.log("$edit !!",$edit,bool,viewType,index)

        },

        updateLocation(data,index,type){
          console.log(data,"updatelocation !!")
            if(type == 'edit'){
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id
                data.modified_name = this.user_name
                this.shippingDetails[index] = data
                this.save()
            }

        },
    }
  };
  </script>
  
  <style scoped>
  .customer{
    display: flex;
    align-items: center;
  }
  .upload-btn {
  /* background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); */
  color: white;
  font-weight: 600;
  text-transform: none; /* keep 'Upload' normal instead of uppercase */
  border-radius: 12px;
  padding: 10px 20px;
  transition: all 0.3s ease;
}
  .clientname {
    font-size: 20px;
    font-weight: 600;
  }
  
  .table-container {
    width: 100%;
     /* background: #ebf1f35a; */
    background: #fff;
    padding: 8px 15px;
    border-radius: 4px;
    /* // border: 1px solid #d2d2d2; */

    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 10px;

        thead {
        border: 1px solid #cbf0fd;
        background-color: #e3f2fd;

        th {
            font-size: 1rem;
            font-weight: 500;
            padding: 12px;
            text-align: left;
            color: #000;
        }
        }

        tbody {
        tr {
            cursor: pointer;
            font-size: 0.9rem;
            font-weight: 500;
            position: relative;
            overflow: hidden;
            border: 1px solid #cbf0fd;
            border-radius: 8px;

            &:nth-child(odd) {
            background-color: #ebf1f3;
            }

            &:nth-child(even) {
            background-color: #d9dbdb;
            }

            td {
            padding: 10px;
            text-align: left;
            color: #333;
            }

            &:hover {
            background-color: #f5f5f5;
            }
        }
        }
    }
    }
    .edit-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    }

    .noWrap{
    text-wrap:nowrap;
    }
    .no-data-container{
    display:flex;
    justify-content:center;
    align-items:center;
    width: 100%;
    height:400px;
    font-size:20px; 
    font-weight:500;
    }
  </style>